<!-- TABS -->
<tec-tabs [tabs]="tabs" />

<!-- TAB: DETAILS -->
@if (tabs.length && tabs[0].selected) {
    <app-operation-detail-tabs-details [detail]="detail" />
}

<!-- TAB: CHECKS -->
@if (tabs.length && tabs[1].selected) {
    <app-operation-detail-tabs-checks [detail]="detail" />
}

<!-- TAB: ACTIVITY -->
@if (tabs.length && tabs[2].selected) {
    <app-operation-detail-tabs-activity [detail]="detail" />
}
